export class OrderService {
    orderApi;
    constructor(api) {
        this.orderApi = api;
    }
    async sendOrder(reg, success, failure) {
        await this.orderApi.sendOrder(reg)
            .then(result => {
            if (success)
                success(result);
        }).catch(error => {
            console.log(error);
            if (failure)
                failure();
        });
    }
    async subscribe(req) {
        return this.orderApi.createSubscription(req);
    }
}
